import { Button } from "$components/button/button";
import { toast } from "$global-providers/toast-provider";
import { CircularProgress, styled } from "@material-ui/core";
import React from "react";
import { useIntl } from "react-intl";

type Props = React.ComponentProps<typeof Button> & { loading?: boolean };

const Spinner = styled(CircularProgress)({ padding: 4 });

/** @deprecated possible-component */
const SubmitButton: FC<Props> = ({ loading, ...delegateProps }) => {
  const { formatMessage } = useIntl();
  const onSubmitAndClickWhenLoading: Props["onSubmit"] = (e) => {
    e.preventDefault();
    toast.info(
      formatMessage({
        id: "submitButton.onSubmit.alreadySubmitting",
        defaultMessage: "Submit already happening, please wait...",
      }),
    );
  };

  return (
    <Button
      {...delegateProps}
      onClick={loading ? onSubmitAndClickWhenLoading : delegateProps.onClick}
      onSubmit={loading ? onSubmitAndClickWhenLoading : delegateProps.onSubmit}
    >
      {loading ? <Spinner /> : delegateProps.children}
    </Button>
  );
};

export default SubmitButton;
